export default __webpack_public_path__ + "static/media/an1.43659517.jpg";